import { Paper } from "@mui/material";
import CustomTab from "components/CustomTab";
import ExportReactCSV from "components/ExportReactCSV";
import { formatArray, groupBy } from "lib/arrayObject";
import { getWeekDaysByWeekNumber } from "lib/date";
import { paymentStatusOption } from "lib/global";
import { useEffect, useMemo, useState } from "react";
import FlavorBreakdown from "../weekly-detail/FlavorBreakdown";
import WeeklySlotsOrderTable from "../weekly-detail/WeeklySlotsOrderTable";

const headers = [
  { label: "Order ID", key: "id" },
  { label: "Order Type", key: "box_type" },
  { label: "Name", key: "name" },
  { label: "Address", key: "address" },
  { label: "Region", key: "region" },
  { label: "Post Code", key: "postcode" },
  { label: "Email", key: "email" },
  { label: "Phone Number", key: "phone_number" },
  { label: "Company Name", key: "companyName" },
  { label: "Delivery Note", key: "deliveryNote" },
  { label: "Stripe ID", key: "paymentIntent" },
  { label: "Payment Status", key: "paymentStatus" },
  { label: "Voucher Code", key: "voucherCode" },
  { label: "Dispatch Date", key: "dispatchDate" },
  { label: "Status", key: "status" },
];

export default function DailySummaryTable({
  data = [],
  pies = [],
  exportType = "week",
  type = "dispatch-date",
  onCloseSummary = () => {},
  dateType = "",
  onReSchedule = () => {},
  ...props
}) {
  const [csvHeaders, setCsvHeaders] = useState([]);
  // const [page, setPage] = useState(1);
  const [activeTab, setActiveTab] = useState({
    label: "All Orders",
    tab: "all",
  });
  const [selected, setSelected] = useState([]);

  const customersData = () => {
    let csvData = selected?.length > 0 ? selected : data;
    let custs = csvData.map((item) => {
      const csvData = {
        id: item?.id ?? "",
        box_type: item?.box_type ? "Sub" : "One Off",
        name: item?.name ?? "",
        address: (item?.order_address ?? item?.address)?.label ?? "",
        region:
          item?.region ?? (item?.order_address ?? item?.address)?.region ?? "",
        email: item?.email ?? "",
        companyName: item?.company_name ?? item?.other?.company_name ?? "",
        deliveryNote: item?.delivery_note ?? item?.other?.box_note ?? "",
        paymentIntent: item?.payment_intent?.id ?? "",
        voucherCode: item?.voucher_code ?? "",
        postcode: (item?.order_address ?? item?.address)?.postcode ?? "",
        phone_number: item?.phone ?? "",
        paymentStatus:
          paymentStatusOption?.find((ele) => ele?.id === item?.paid)?.label ??
          "",
        dispatchDate: getWeekDaysByWeekNumber({
          weekNumber: Boolean(item?.week_next_num)
            ? item?.week_next_num
            : item?.week_num,
          addDay: item?.week_day - 1,
          format: "DD MMM, YYYY",
          yearNumber: item?.week_year,
        }),
        status: Boolean(item?.tracking_info?.consignmentId)
          ? "Fulfilled"
          : "Unfulfilled",
      };
      const rowPies = groupBy(
        formatArray(item?.pies)?.filter((pie) => pie),
        "id"
      );
      const piesData = Object.keys(rowPies).reduce(
        (ret, pieId) => ({
          ...ret,
          [pieId.toString()]: rowPies?.[pieId]?.length,
        }),
        {}
      );
      return { ...csvData, ...piesData };
    });
    return custs;
  };
  const flavorHeader = [
    {
      key: "name",
      label: "Name",
    },
    { label: "Count", key: "count" },
    { label: "Percent", key: "percent" },
  ];
  const flavourData = () => {
    const allPies = data?.reduce(
      (ret, cur) => [...ret, ...(cur?.pies ?? [])],
      []
    );
    const pies = groupBy(
      formatArray(allPies)?.filter((pie) => pie),
      "id"
    );
    let custs = Object.keys(pies)?.map((key) => ({
      name: pies[key]?.[0]?.name,
      count: pies[key].length,
      percent: `${((pies[key].length / allPies.length) * 100).toFixed("2")}%`,
    }));
    return custs;
  };
  const exportName = useMemo(() => {
    const slotType =
      type === "dispatch-date"
        ? activeTab?.tab === "all"
          ? `Dispatch - Orders`
          : `Dispatch - Flavours`
        : activeTab?.tab === "all"
        ? `Bake - Orders`
        : `Bake - Flavours`;
    return `${slotType} [${dateType}]`;
    //eslint-disable-next-line
  }, [type, exportType, data, activeTab]);

  useEffect(() => {
    if (pies?.length === 0) return;
    const piesHeader = pies.reduce(
      (ret, cur) => [...ret, { label: cur?.name, key: cur.id.toString() }],
      []
    );
    setCsvHeaders((s = []) => [...headers, ...piesHeader]);
    //eslint-disable-next-line
  }, [pies]);

  return (
    <div className="my-4">
      <div className="flex justify-between items-center">
        <CustomTab
          tabs={[
            { label: "All Orders", tab: "all" },
            { label: "Flavor Breakdown", tab: "flavor" },
          ]}
          activeTab={activeTab}
          onClick={(tab) => setActiveTab(tab)}
        />
        <div className="flex items-center">
          <ExportReactCSV
            csvHeaders={activeTab.tab === "all" ? csvHeaders : flavorHeader}
            csvData={activeTab.tab === "all" ? customersData() : flavourData()}
            fileName={`${exportName}.csv`}
          />
        </div>
      </div>
      {activeTab?.tab === "all" ? (
        <WeeklySlotsOrderTable
          data={data}
          type={type}
          count={data?.length}
          onCloseSummary={onCloseSummary}
          onSelected={(data) => setSelected(data)}
          onReSchedule = {onReSchedule}
          {...props}
        />
      ) : (
        <Paper className="p-4 bg-white h-56 overflow-auto">
          <FlavorBreakdown data={data} />
        </Paper>
      )}
    </div>
  );
}
